import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { CommonService } from "src/app/services/common.service";
import { SupportTicketService } from "../support-ticket.service";
import { BsModalRef } from "ngx-bootstrap";

@Component({
  selector: "app-support-ticket-form",
  templateUrl: "./support-ticket-form.component.html",
  styleUrls: ["./support-ticket-form.component.sass"],
})
export class SupportTicketFormComponent implements OnInit {
  optionsVisibility = {};
  category = "";
  isLoading = false;
  users = [];
  images = [""];
  video = "";
  selectedUser = {};
  isValid = false;
  submitted = false;
  formData: FormGroup;
  fileToUpload: File = null;

  private initialData = {
    _id: "",
    employeeId: "",
    customerName: "",
    phoneNumber: "",
    quoteCode: "",
    address: "",
    name: "",
    date: "",
    video: "",
    typeOfIssue: "",
    descriptionIssue: "",
    users: {},
    images: [],
  };

  constructor(
    private _fb: FormBuilder,
    private bsModalRef: BsModalRef,
    private api: SupportTicketService,
    private commonService: CommonService
  ) {}

  ngOnInit() {
    this.formData = this._fb.group({
      employeeId: [this.initialData.employeeId],
      customerName: [this.initialData.customerName, [Validators.required]],
      phoneNumber: [this.initialData.phoneNumber, [Validators.required]],
      quoteCode: [this.initialData.quoteCode, [Validators.required]],
      address: [this.initialData.address, [Validators.required]],
      name: [this.initialData.name, [Validators.required]],
      date: [
        this.getCurrentDate(new Date(this.initialData.date)),
        [Validators.required],
      ],
      typeOfIssue: [this.initialData.typeOfIssue, [Validators.required]],
      descriptionIssue: [
        this.initialData.descriptionIssue,
        [Validators.required],
      ],
    });

    this.handleUserSearch("");
    this.formData.patchValue({
      employeeId: this.initialData.employeeId,
    });

    this.selectedUser = this.initialData.users || {};
    this.images = this.initialData.images;
    this.video = this.initialData.video;
  }

  get f() {
    return this.formData.controls;
  }
  get today(): string {
    const today = new Date();
    const year = today.getFullYear();
    const month = ("0" + (today.getMonth() + 1)).slice(-2);
    const day = ("0" + today.getDate()).slice(-2);
    return `${year}-${month}-${day}`;
  }

  addImages() {
    if (this.isLoading) {
      return this.commonService.toast("uploading Doc", "Info");
    }
    this.images.push("");
  }

  removeimage(index: number) {
    if (this.images.length > 1) {
      this.images.splice(index, 1);
    } else {
      this.images[0] = "";
    }
  }

  removeVideo() {
    this.video = "";
  }

  getCurrentDate(date: Date): string {
    // Format date as YYYY-MM-DD
    return date.toISOString().split("T")[0];
  }

  closeModal(): void {
    this.bsModalRef.hide();
  }

  handleOptionVisibility(event: any, isShow: boolean) {
    const name = event.target.name;

    setTimeout(() => {
      this.optionsVisibility[name] = isShow;
    }, 500);
  }

  handleUserSearch(event: any) {
    const str = event ? event.target.value : "";

    const data = {
      search: str,
    };

    this.api.getUsers(data).subscribe(
      (result: any) => {
        const response = result.data;

        if (response.items) {
          this.users = response.items;
        }
      },
      (error: any) => {
        this.commonService.toast(error.error.message, "Error");
      }
    );

    this.selectedUser = {};
    this.formData.patchValue({
      employeeId: "",
    });
  }

  handleUserSelect(item: any) {
    this.selectedUser = item;

    this.formData.patchValue({
      employeeId: item._id,
    });
  }

  handleFileInput(files: FileList, type = "image") {
    this.fileToUpload = files.item(0);

    if (files.length === 1) {
      this.isLoading = true;
      this.commonService.fileUpload(this.fileToUpload).subscribe(
        (result: any) => {
          this.isLoading = false;

          if (type === "image") {
            this.images.pop();
            this.images.push(result.data);
          } else {
            this.video = result.data;
          }
        },
        (error: any) => {
          this.isLoading = false;
          this.commonService.toast(error.error.message, "Error");
        }
      );
    }
  }

  handleSubmit() {
    this.submitted = true;

    if (this.formData.valid && this.isLoading === false) {
      const formData = this.formData.value;
      this.isLoading = true;

      this.api
        .updateTicketData(this.initialData._id, {
          ...formData,
          video: this.video,
          images: this.images.filter((data) => data !== ""),
        })
        .subscribe(
          (result: any) => {
            this.isLoading = false;
            this.commonService.toast(result.message, "Success");
            this.closeModal();
            this.submitted = false;
          },
          (error: any) => {
            this.commonService.toast(error.error.message, "Error");
          }
        );
    }
  }
}
